import { SurveyPreInterviewTemplateTableBean } from './SurveyPreInterviewTemplateInteractiveTable.types';

export const addEmptyRow = (): SurveyPreInterviewTemplateTableBean => ({
   content: '',
});
